import type { PathOptions } from 'leaflet';

export const GEOFENCE_INSIDE_COLOR = '#06b500';
export const GEOFENCE_OUTSIDE_COLOR = '#f00';

export type TLocationGeofence = {
  meters: number;
  outside: boolean;
};

type TDistanceLike = {
  meters?: unknown;
  outside?: unknown;
};

type TItemWithDistance = {
  distance?: TDistanceLike | null;
};

export const getGeofenceFromMapItem = (item: unknown): TLocationGeofence | null => {
  if (!item || typeof item !== 'object') {
    return null;
  }

  const distance = (item as TItemWithDistance).distance;
  const meters = distance?.meters;
  if (typeof meters !== 'number' || !Number.isFinite(meters) || meters <= 0) {
    return null;
  }

  return {
    meters,
    outside: distance?.outside === true,
  };
};

export const getGeofencePathOptions = (outside: boolean): PathOptions => {
  const color = outside ? GEOFENCE_OUTSIDE_COLOR : GEOFENCE_INSIDE_COLOR;

  return {
    color,
    fillColor: color,
    fillOpacity: 0.2,
    weight: 2,
  };
};
